// src/utils/imageCompressor.js
/**
 * Helper para redimensionar y comprimir imágenes (logos y firmas) en el navegador
 * evitando exceder el límite de 1MB por documento en Firestore.
 */
export const comprimirImagen = (file, maxAncho = 500, maxAlto = 250, calidad = 0.85) => {
    return new Promise((resolve, reject) => {
        if (!file) {
            reject(new Error("No se proporcionó ningún archivo."));
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                let ancho = img.width;
                let alto = img.height;

                // Calcular nuevas dimensiones manteniendo la relación de aspecto
                if (ancho > maxAncho || alto > maxAlto) {
                    if (ancho / maxAncho > alto / maxAlto) {
                        alto = Math.round((alto * maxAncho) / ancho);
                        ancho = maxAncho;
                    } else {
                        ancho = Math.round((ancho * maxAlto) / alto);
                        alto = maxAlto;
                    }
                }

                const canvas = document.createElement('canvas');
                canvas.width = ancho;
                canvas.height = alto;

                const ctx = canvas.getContext('2d');
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';
                ctx.drawImage(img, 0, 0, ancho, alto);

                // Convertir a base64 PNG para preservar transparencias
                const dataUrlComprimido = canvas.toDataURL('image/png', calidad);
                resolve(dataUrlComprimido);
            };
            img.onerror = (err) => reject(err);
        };
        reader.onerror = (err) => reject(err);
    });
};
